import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Card } from 'reactstrap'

import { getDishImageUrl, decodeHtml } from '@utils'
import { customToast } from '@common'

const MenuItem = ({ item, onSelectProduct }) => {
    const { name, description, vendorName, servingTimes, isService, isAllVariantSoldOut } = item
    const [imageError, setImageError] = useState(false)

    const onItemClick = () => {
        if (!isService) {
            customToast.plain(
                'Available from\n' + servingTimes.map(time => `${time.days.join(', ')}: ${time.open} - ${time.close}`).join('\n'),
                {
                    duration: 5000,
                    icon: <i className="bx bx-sm bx-time"></i>,
                    isShowCloseButton: false,
                }
            )
        } else if (isAllVariantSoldOut) {
            customToast.plain('All variants are sold out', {
                duration: 5000,
                icon: <i className="bx bx-sm bx-error text-danger"></i>,
            })
        } else {
            onSelectProduct(item)
        }
    }

    const _renderPrice = () => {
        if (!item.variants?.length) return null
        const { lowestPrice } = item

        // If have no price variant
        if (lowestPrice === Infinity) {
            return 'Ala carte price'
        }

        return `${item.variants.length > 1 ? 'From ' : ''}$${lowestPrice.toFixed(2)}`
    }

    return (
        <Card className={`menu-item-card ${!isService || isAllVariantSoldOut ? 'disabled' : ''}`}>
            <div className="menu-item-wrapper">
                {/* Left: Image */}
                <div className="menu-item-image-container">
                    {item.dishId && !imageError ?
                        <img
                            src={getDishImageUrl(item.dishId)}
                            alt={name}
                            className="menu-item-image"
                            onError={() => setImageError(true)}
                        />
                    :   <div className="menu-item-placeholder">
                            <i className="bx bx-image-alt" style={{ fontSize: '32px', color: '#ccc' }} />
                        </div>
                    }
                </div>

                {/* Middle: Content */}
                <div className="menu-item-content" onClick={() => onItemClick()}>
                    <h5 className={`menu-item-name ${isService && isAllVariantSoldOut ? 'text-danger' : ''}`}>
                        {name} {isService && isAllVariantSoldOut ? ' (Sold out)' : ''}
                    </h5>
                    {description && (
                        <p className="menu-item-desc">
                            {decodeHtml(description)
                                .replace(/<br\s*\/?>/gi, ' ')
                                .replace(/<[^>]*>/g, '')}
                        </p>
                    )}
                    <p className="menu-item-price">{_renderPrice()}</p>
                </div>

                {/* Right: Add Button */}
                <button
                    className="menu-item-add-btn"
                    onClick={() => onItemClick()}
                    disabled={!isService || isAllVariantSoldOut}
                    aria-label="Add to order"
                >
                    <i className="bx bx-plus" />
                </button>
            </div>
        </Card>
    )
}

MenuItem.propTypes = {
    key: PropTypes.number,
    item: PropTypes.object,
    quantity: PropTypes.number,
    onSelectProduct: PropTypes.func,
}

export default MenuItem

const retrieveVendorColor = vendorName => {
    switch (vendorName) {
        case 'Tian Tian Hainanese Chicken Rice':
            return '#6AB6E0'
        case 'Bistro Sedap (Halal)':
            return '#7AAA77'
        case 'Kampong Sedap (Halal)':
            return '#5FAE78'
        case 'Wok of Art ':
            return '#F4A300'
        default:
            return '#9DA3AA'
    }
}
